import { render, staticRenderFns } from "./ConfigureUploads.vue?vue&type=template&id=e2ee2efc&"
import script from "./ConfigureUploads.vue?vue&type=script&lang=js&"
export * from "./ConfigureUploads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports